// extracted by mini-css-extract-plugin
module.exports = {"community-page-B":"B_community-page-B__9EZ4O"};